import { render } from "./TabRadio.vue?vue&type=template&id=3664167c&ts=true"
import script from "./TabRadio.vue?vue&type=script&lang=ts"
export * from "./TabRadio.vue?vue&type=script&lang=ts"

import "./TabRadio.vue?vue&type=style&index=0&id=3664167c&lang=scss"

import exportComponent from "/home/node/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__